/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

app-settings.js - Front-end settings


*/

const appSettings = {
  // in seconds
  linkRefreshTimer: 20,
  notificationCloseTimer: 3,
  clickFlag: false,

  csrfToken:
    document.getElementsByName('csrf-token')[0] !== undefined
      ? document.getElementsByName('csrf-token')[0].getAttribute('content')
      : '',

  modals: {
    exportModal: {
      id: 'export-modal',
      title: 'Export Your Data?',
      content:
        'This will export all of your link data in .JSON format. Proceed?',
      buttonText: 'Export',
      clickHandler: () => {
        window.location.href = '/export';
        loader(5000);
      },
    },

    csrfModal: {
      id: 'csrf-error-modal',
      title: 'Session Expired',
      content:
        'This action has been blocked for security reasons. Please refresh the page and try again.',
      buttonText: 'Refresh?',
      clickHandler: () => {
        window.location.reload();
      },
    },

    bulkDeletionModal: {
      id: 'bulk-deletion-modal',
      title: 'Delete Multiple Links?',
      content:
        'All of the links you have selected below will be deleted. Proceed?',
      buttonText: 'Delete Selected',
    },

    categories: {
      catRenameModal: {
        id: 'rename-warning-modal',
        title: 'Rename This Category',
        content:
          'This will rename the category everywhere it appears throughout your account.',
        clickHandler: () => {
          editCategory(document.getElementById('rename-form'));
        },
      },

      catMoveModal: {
        id: 'move-form-modal',
        title: 'Move This Category',
        content:
          'This will move the current category to the new parent category you specify below; it will become a subcategory of this new parent.',
        clickHandler: () => {
          editCategory(document.getElementById('move-form'));
        },
      },

      catCreateModal: {
        id: 'subcategory-form-modal',
        title: 'Create a Subcategory',
        content:
          'This will create a new subcategory within the one you are currently viewing.',
        clickHandler: () => {
          editCategory(document.getElementById('subcategory-form'));
        },
      },

      catDeleteModal: {
        id: 'delete-warning-modal',
        // fetch query term with the IIFE below
        title: `Are you sure you want to delete the \u00A0<span class=\"inverse-term\">${
          (() => {
            return document.querySelector('.term') || false;
          })().innerText
        }</span>\u00A0category?`,
        content:
          'This will permanently delete the category, and mark all of its links as <strong>UNCATEGORIZED</strong>. Is that what you want to do?',
        buttonText: 'Delete',
        clickHandler: () => {
          window.location.href = `/category/${(() => {
            return document.querySelector('.term') || false;
          })().innerText.toLowerCase()}/delete`;
        },
      },
    },
  },

  notifications: {
    settingsUpdate: {
      title: 'saved',
      text: 'Your settings have been updated.',
    },

    failed: {
      title: 'failed',
      text: 'There was a problem; reload the page and try again.',
    },

    editError: {
      title: 'Edit Failed',
      text: 'There was a problem in editing your link.',
    },
  },

  customEvents: {
    // dispatch this to refresh linklist
    fetchReadyEvent: new CustomEvent('ready-to-fetch'),
    // Define a custom event that will trigger the modal
    csrfError: new CustomEvent('csrf-error'),
  },

  // Tagslist is an empty array on init
  tagsList: [],
};
